import $ from 'jquery'
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import {
  hierarchicalMenu,
  configure,
  refinementList,
  clearRefinements,
} from 'instantsearch.js/es/widgets'
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import { history } from 'instantsearch.js/es/lib/routers'
import { productHit, productButtun } from '../components/productHit'
import infiniteHits from '../components/infiniteHits'
import showMoreText from '../components/showMoreText'
import searchBox from '../components/searchBox'
import { algoliaAppId, algoliaApiKey, productSearchIndex } from '../variables'
import { lockBody, unlockBody } from '../utiils'
import { dynamicUriTemplate, extractParamsFromUri } from '../functions'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const {
  mainSlug,
  query,
  productTypes,
  productFamilies,
  labels,
  brand,
  jobs,
  attributes,
} = object.productsQueryStrings

const slugs = {
  query,
  productTypes,
  productFamilies,
  labels,
  brand,
  jobs,
  attributes,
}

let productSearch
const checkEl = document.querySelector('.pt-products__posts')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)

  productSearch = instantsearch({
    indexName: productSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      router: history({
        createURL({ routeState, location }) {
          const params = {
            productTypes: routeState.productTypes,
            productFamilies: routeState.productFamilies,
            labels: routeState.labels,
            brand: routeState.brand,
            jobs: routeState.jobs,
            query: routeState.query,
            attributes: routeState.attributes,
          }

          return dynamicUriTemplate(location.origin, params, mainSlug, slugs)
        },

        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs)

          return {
            query: params[slugs.query] && params[slugs.query][0],
            productTypes: params[slugs.productTypes],
            productFamilies: params[slugs.productFamilies],
            labels: params[slugs.labels],
            brand: params[slugs.brand],
            jobs: params[slugs.jobs],
            attributes: params[slugs.attributes],
          }
        },
      }),

      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[productSearchIndex] || {}

          const res = {
            query: indexUiState.query,
            productTypes: indexUiState.refinementList?.['productTypes.name'],
            productFamilies:
              indexUiState.hierarchicalMenu?.['productFamilies.lvl0'],
            labels: indexUiState.refinementList?.['labels.name'],
            brand: indexUiState.refinementList?.['brand.name'],
            jobs: indexUiState.refinementList?.['jobs.name'],
            attributes: indexUiState.refinementList?.['attributes'],
          }
          return res
        },

        routeToState(routeState) {
          return {
            [productSearchIndex]: {
              query: routeState.query,
              refinementList: {
                'productTypes.name': routeState.productTypes,
                'labels.name': routeState.labels,
                'brand.name': routeState.brand,
                'jobs.name': routeState.jobs,
                attributes: routeState.attributes,
              },
              hierarchicalMenu: {
                'productFamilies.lvl0': routeState.productFamilies,
              },
            },
          }
        },
      },
    },
  })

  const customSearchBox = connectSearchBox(searchBox)
  const customInfiniteHits = connectInfiniteHits(
    infiniteHits(productHit, productButtun)
  )

  productSearch.addWidgets([
    customSearchBox({
      container: document.querySelector('.product-search-handler'),
      placeholder: __('Search...', 'vn'),
    }),

    clearRefinements({
      container: '.product-active-filters-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<span
            >${hasRefinements
              ? __('Remove filters', 'vn')
              : __('No filters', 'vn')}</span
          >`
        },
      },
    }),

    refinementList({
      container: '.product-types-handler',
      attribute: 'productTypes.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    hierarchicalMenu({
      container: '.product-families-handler',
      attributes: [
        'productFamilies.lvl0',
        'productFamilies.lvl1',
        'productFamilies.lvl2',
      ],
      sortBy: ['name'],
      limit: 999,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    refinementList({
      container: '.product-labels-handler',
      attribute: 'labels.name',
      sortBy: ['name'],
      limit: 999,
      /*showMoreLimit: 999,
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },*/
    }),

    refinementList({
      container: '.product-brands-handler',
      attribute: 'brand.name',
      sortBy: ['name'],
      limit: 999,
      /*showMoreLimit: 999,
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },*/
    }),

    refinementList({
      container: '.product-attributes-handler',
      attribute: 'attributes',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),

    /*refinementList({
      container: '.product-jobs-handler',
      attribute: 'jobs.name',
      sortBy: ['name'],
      showMore: true,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
      },
    }),*/

    customInfiniteHits({
      container: document.querySelector('.product-hits-handler'),
    }),

    configure({
      hitsPerPage: 15,
    }),
  ])

  $(document).on(
    'click',
    '.pt-products .filter-sidebar__widget label, .pt-products .filter-sidebar__widget .hierarchical-menu',
    function () {
      document.querySelector('.pt-products__grid').scrollIntoView({
        behavior: 'smooth',
      })
    }
  )

  productSearch.on(
    'render',
    () => {
      let scrollStarted = true
      if (window.onscrollend !== undefined && !scrollStarted) {
        addEventListener(
          'scrollend',
          () => {
            scrollStarted = false
          },
          {
            once: true,
          }
        )
        document
          .querySelector('.pt-products__posts')
          .scrollIntoView({ behavior: 'smooth' })
        scrollStarted = false
      }
    },
    { once: true }
  )

  productSearch.start()
}

const openFilter = () => {
  document.querySelector('.filter-sidebar-col').classList.add('active')
  lockBody()
}

const closeFilter = () => {
  document.querySelector('.filter-sidebar-col').classList.remove('active')
  unlockBody()
  document
    .querySelector('.pt-products__posts')
    .scrollIntoView({ behavior: 'smooth' })
}

const opener = document.querySelector('.filter-sidebar-opener')
const filterEl = document.querySelector('.filter-sidebar-col')
const closers = document.querySelectorAll('.filter-actions button')

opener && opener.addEventListener('click', openFilter)
filterEl &&
  filterEl.addEventListener(
    'click',
    (e) => e.target === filterEl && closeFilter()
  )
if (closers.length) {
  ;[...closers].map((closer) => {
    closer.addEventListener('click', closeFilter)
  })
}

$('.filter-sidebar__widget-title').on('click', function () {
  if (!window.matchMedia('(max-width: 991.98px)').matches) {
    return
  }

  const title = $(this)
  const parent = title.parent()
  const icon = parent.find('.filter-sidebar__widget-title-icon')
  const content = parent.find('.filter-sidebar__widget-content')

  content.slideToggle(250)
  parent.toggleClass('active')
  icon.toggleClass('vn-icons-arrow-down-circle vn-icons-arrow-up-circle')
})

export { productSearch }
